import React from "react";
import {
  Modal,
  Descriptions,
  Typography,
  Space,
  Tag,
  Button,
  message,
} from "antd";
import { SummaryListItem } from "../../../../types/dataControl";

const { Text } = Typography;

interface SummaryDetailModalProps {
  visible: boolean;
  data: SummaryListItem | null;
  onClose: () => void;
}

const SummaryDetailModal: React.FC<SummaryDetailModalProps> = ({
  visible,
  data,
  onClose,
}) => {
  if (!data) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(data.summary);
    message.success("摘要已复制到剪贴板");
  };

  return (
    <Modal
      title={
        <Space>
          <i className="ri-file-text-line" style={{ color: "#1677ff" }} />
          摘要详情
        </Space>
      }
      open={visible}
      onCancel={onClose}
      width={800}
      footer={[
        <Button key="close" onClick={onClose}>
          关闭
        </Button>,
        <Button
          key="copy"
          type="default"
          icon={<i className="ri-file-copy-line" />}
          onClick={handleCopy}
        >
          复制摘要
        </Button>,
      ]}
    >
      <div style={{ maxHeight: "70vh", overflow: "auto" }}>
        <Descriptions bordered column={1} size="small">
          <Descriptions.Item label="ID">{data.id}</Descriptions.Item>
          <Descriptions.Item label="用户ID">{data.open_id}</Descriptions.Item>
          <Descriptions.Item label="邮箱">
            {data.email !== "NULL" ? data.email : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="项目Key">
            <Text copyable>{data.project_key}</Text>
          </Descriptions.Item>
          <Descriptions.Item label="标题">{data.title}</Descriptions.Item>
          <Descriptions.Item label="URL">
            <a href={data.url} target="_blank" rel="noopener noreferrer">
              {data.url}
            </a>
          </Descriptions.Item>
          <Descriptions.Item label="引用来源">{data.refer}</Descriptions.Item>
          <Descriptions.Item label="生成时间">
            {new Date(data.created_at).toLocaleString("zh-CN")}
          </Descriptions.Item>
          <Descriptions.Item label="属性">
            <Space wrap>
              <Tag color={data.is_vector ? "green" : "default"}>
                {data.is_vector ? "已向量化" : "未向量化"}
              </Tag>
              <Tag color="blue">{data.language}</Tag>
              <Tag color="purple">{data.doc_type}</Tag>
            </Space>
          </Descriptions.Item>
          <Descriptions.Item label="摘要内容">
            <div
              style={{
                padding: "12px",
                border: "1px solid #f0f0f0",
                borderRadius: "4px",
                background: "#fafafa",
              }}
            >
              {data.summary}
            </div>
          </Descriptions.Item>
          <Descriptions.Item label="原文内容">
            <div
              style={{
                padding: "12px",
                border: "1px solid #f0f0f0",
                borderRadius: "4px",
                background: "#fafafa",
                maxHeight: "300px",
                overflow: "auto",
              }}
            >
              {data.content}
            </div>
          </Descriptions.Item>
        </Descriptions>
      </div>
    </Modal>
  );
};

export default SummaryDetailModal;
